/** Must match backend ``WEBSOCKET_CREDENTIAL_REFRESH_INTERVAL_SECONDS``. */
export const WS_CREDENTIAL_REFRESH_INTERVAL_MS = 60 * 60 * 1000

/** Default TTL when ``expires_at`` is missing (3 hours). */
export const WS_CREDENTIAL_TTL_MS = 3 * 60 * 60 * 1000

export const WS_CMD_REFRESH_CREDENTIALS = "refresh_credentials"
export const WS_CMD_REALTIME_MISSING_FRAMES = "realtime_missing_frames"
export const WS_EVENT_WEBSOCKET_CREDENTIALS = "websocket_credentials"
export const WS_EVENT_REALTIME_FRAMES = "realtime_frames"
export const WS_EVENT_REALTIME_FRAMES_MISSING = "realtime_frames_missing"
